import React, { useEffect, useState } from 'react'
import useSWR from 'swr'
import PropTypes from 'prop-types'
import { ENDPOINTS } from 'lib/api/const'
import { requestWithCache } from 'lib/api'
import ResponsiveImage from 'components/images/responsive-image'
import env from 'config/env'
import YellowSection from './yellow-section'
import GreenSection from './green-section'
import PurpleSection from './purple-section'
import PinkSection from './pink-section'

function loadLottieScript(onLoadFn) {
  const LOTTIE_SCRIPT_ID = 'lottie_script'

  if (document.getElementById(LOTTIE_SCRIPT_ID)) {
    onLoadFn()
  }

  const newScript = document.createElement('script')
  newScript.setAttribute('id', LOTTIE_SCRIPT_ID)
  newScript.setAttribute(
    'src',
    'https://cdnjs.cloudflare.com/ajax/libs/bodymovin/5.6.7/lottie_svg.min.js',
  )
  newScript.onload = onLoadFn
  document.body.appendChild(newScript)
}

const FETCH_INTERVAL = 60000

const PomeloCaresMobile = ({
  contents: initialData,
  country,
  isThankYouPage,
  language,
  t,
}) => {
  // eslint-disable-next-line prefer-const
  let { data, error } = useSWR(
    !isThankYouPage && [
      ENDPOINTS.pomeloCares.link,
      JSON.stringify({ includeServerTime: true }),
    ],
    requestWithCache,
    {
      dedupingInterval: ENDPOINTS.pomeloCares.cache,
      initialData,
      refreshInterval: FETCH_INTERVAL,
    },
  )
  const [isLottieReady, setIsLottieReady] = useState(false)

  useEffect(() => {
    if (!isThankYouPage) {
      loadLottieScript(() => setIsLottieReady(true))
    }
  }, [isThankYouPage])

  if (isThankYouPage) {
    return (
      <YellowSection
        country={country}
        isThankYouPage
        language={language}
        t={t}
      />
    )
  }

  if (error) {
    // return "Can't fetch data"
  }

  if (!data) {
    data = {
      masks: '-',
      paypal_money_raised: '-',
      masks_money_raised: '-',
      server_time: '',
      initial_time: null,
    }
  }

  return (
    <React.Fragment>
      <YellowSection
        amount={data.paypal_money_raised}
        country={country}
        isLottieReady={isLottieReady}
        language={language}
        t={t}
      />
      <GreenSection t={t} />
      <ResponsiveImage
        src={`${env.IMG_HOST}img/pomelo-cares/barcode.svg`}
        imgRatio={0.0888888889}
      />
      {(country === 'th' || country === 'sg' || country === 'id') && (
        <React.Fragment>
          <PurpleSection
            amount={data.masks_money_raised}
            country={country}
            isLottieReady={isLottieReady}
            language={language}
            masks={data.masks}
            t={t}
          />
          <ResponsiveImage
            src={`${env.IMG_HOST}img/pomelo-cares/barcode.svg`}
            imgRatio={0.0888888889}
          />
        </React.Fragment>
      )}
      <PinkSection
        initialTime={data.initial_time}
        language={language}
        serverTime={data.server_time}
        t={t}
      />
    </React.Fragment>
  )
}

PomeloCaresMobile.propTypes = {
  contents: PropTypes.shape({
    masks: PropTypes.number,
    hospitals: PropTypes.number,
    paypal_money_raised: PropTypes.string,
    masks_money_raised: PropTypes.string,
    server_time: PropTypes.string,
    initial_time: PropTypes.shape({
      day: PropTypes.string,
      hour: PropTypes.string,
      minute: PropTypes.string,
      second: PropTypes.string,
    }),
  }),
  country: PropTypes.string.isRequired,
  isThankYouPage: PropTypes.bool.isRequired,
  language: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}

PomeloCaresMobile.defaultProps = {
  contents: null,
}

export default PomeloCaresMobile
